import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISubCategoryDetails } from './typings';
import { Observable } from 'rxjs';
import { env } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(
    private http: HttpClient
  ) { }

  getSubCategoryDetails(codeId: any): Observable<ISubCategoryDetails> {
    const authToken = sessionStorage.getItem('Token'); // Retrieve the token from sessionStorage
    const headers: { [header: string]: string } = authToken
      ? { Authorization: `Bearer ${authToken}` } // Add the Authorization header if the token exists
      : {}; 
    
  
    return this.http.get<ISubCategoryDetails>(
      `${env.API.get_sub_category_details_byId_url}?codeId=${codeId}&isExternal=false`,
      { headers } // Pass the headers explicitly
    );
  }
}
